'use strict';

import React, { useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IRootState } from 'app/shared/reducers';
import { loading, failure, success, RD, SRD } from 'srd';
import { IsMobile } from 'app/app';
import { Button, Progress } from 'reactstrap';
import StepActions from '../step-actions/step-actions';
import StepMessage from '../step-message/step-message';
import { getContent } from 'app/modules/cms/service/store/cms-selectors';
import { goNextStep, goPreviousStep, initStep } from 'app/modules/journey/service/step.service';
import { getCurrentComponent, getCurrentJourneyStep, getCurrentPageType, getCurrentShowStepActions, getCurrentStep, nbShowStepActions } from 'app/modules/journey/service/store/step.selector';
import { LoadingSpinner } from 'app/shared/components/loading';
import { AlertDanger } from 'app/shared/components/alert';
import { scrollToTop } from 'app/shared/util/method-util';

import './step-generic.scss';
import ContentLoader from 'react-content-loader';
import { associativeSkelMap } from '../../tools/mapperSkeleton';
import { associativeMobileSkelMap } from '../../tools/mapperMobileSkeleton';
import CustomProgress from './custom-progress';
import { loadTotalProgressSteps } from 'app/modules/config/service/store/config.selector';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const GenericStep = () => {

  const isMobile = useContext(IsMobile);

  const dispatch = useDispatch();

  const errorCms = useSelector((state: IRootState) => state.cms.error);
  const stepsLoaded = useSelector((state: IRootState) => state.step.stepsLoaded);

  const stepNum = useSelector(getCurrentStep);
  // const stepLength = useSelector(nbShowStepActions);
  const currentJourneyStep = useSelector(getCurrentJourneyStep);
  const currentPageType = useSelector(getCurrentPageType);
  const currentShowStepActions = useSelector(getCurrentShowStepActions);
  const currentComponent = useSelector(getCurrentComponent);
  const cmsContentPageType = useSelector(getContent(currentPageType));
  const stepLength = useSelector(loadTotalProgressSteps)

  const showPreviousButton = useSelector((state: IRootState) => state.step.showPreviousButton)
  const previousButtonLabel = useSelector((state: IRootState) => state.step.previousButtonLabel)
  const disableButtons = useSelector((state: IRootState) => state.step.disableButtons)
  const disablePreviousButton = useSelector((state: IRootState) => state.step.disablePreviousButton)
  const disableNextButton = useSelector((state: IRootState) => state.step.disableNextButton)

  const [stepGenericSRD, setStepGenericSRD] = React.useState<RD<string, number>>(loading())
  const [progressStep, setProgressStep] = useState(0)

  const handleGoNextStep = (event) => {
    if (event.key === 'Enter' && !disableNextButton) {
      dispatch(goNextStep())
    }
  }

  useEffect(() => {
    if (stepsLoaded) dispatch(initStep());
  }, [stepsLoaded])

  useEffect(() => {
    setTimeout(() => {
      setProgressStep(stepNum / stepLength * 100)
    }, 200)
  }, [stepNum])

  useEffect(() => {
    window.addEventListener('keydown', handleGoNextStep);

    return () => {
      window.removeEventListener('keydown', handleGoNextStep);
    }
  }, []);

  useEffect(() => {
    if (errorCms) {
      setStepGenericSRD(failure(errorCms));
    }
  }, [errorCms]);

  useEffect(() => {
    scrollToTop();
    setStepGenericSRD(loading());
    // setTimeout(() => {
    if (currentPageType !== undefined) {
      if (cmsContentPageType !== undefined) {
        setStepGenericSRD(success(currentJourneyStep))
      }
    } else {
      setStepGenericSRD(success(currentJourneyStep))
    }
    // }, 2000);
  }, [currentJourneyStep, currentPageType, cmsContentPageType])

  const handleGoToPreviousStepEvent = (): void => {
    dispatch(goPreviousStep());
  }

  const view = SRD.match({
    notAsked: () => <div></div>,
    loading: () => !isMobile ? associativeSkelMap.get(currentJourneyStep) : associativeMobileSkelMap.get(currentJourneyStep),
    failure: (e) => <AlertDanger><span>{"Une erreur s'est produite"}</span>{e && <span> :<br />{e}</span>}</AlertDanger>,
    success: (num) => <>
      {!isMobile &&
        <>
          {currentJourneyStep !== 'cancellationStep' && <StepMessage />}
        </>}
      {/* <Progress color="danger" value={progressStep.toString()} /> */}
      {showPreviousButton ?
          <div className="top-previous-button float-left" onClick={handleGoToPreviousStepEvent}>
            <Button tabIndex={1} className="button previousButton" disabled={disableButtons || disablePreviousButton}>
              {/* <i className="zmdi zmdi-arrow-left" /> */}
              <FontAwesomeIcon icon="chevron-left" />
              <span>{previousButtonLabel}</span>
            </Button>
          </div>
          : <div></div>
        }

      {currentJourneyStep !== 'endStep' &&
        <CustomProgress progressStep={stepNum} totalSteps={stepLength - 1} />}
      {currentComponent}
      {currentShowStepActions && <StepActions />}
    </>
  }, stepGenericSRD)

  return view
}

export default GenericStep
